// Session expires in 24 hours
export const SESSION_EXPIRY_TIME = 24 * 60 * 60 * 1000

export const USER_SESSION_KEY = 'user'
export const SESSION_EXPIRY_KEY = 'sessionExpiry'

// Regex for number id
export const REGEX_NUMBER_ID = /^\d+$/

export const DEFAULT_SEO_IMAGE =
  'https://fsds-content-prod.s3.ap-southeast-1.amazonaws.com/uploads/47b0c5bae45f9035b3716830f28d6c41ce802551e3902c2fd01aa9c12ee59a14.jpg'
